// removed by extract-text-webpack-plugin
module.exports = {"copyright":"_1KSWNsnWO961jCW4DmcaKb","copyright___text":"HsxEuvXno--gR3RRzKofI","footer":"_10iLVuqhJzs0Co1fnXHHAK","footer__inner":"_2snnKh7MztIh5OSzAe2ZfK","brand":"_2lvzNCdd_eEgLakSLlb2Uk","footer-fb":"_1lXTzLulJ50thtrsQbHXaS","nav":"od5zyX7EhQEGvk1K__Zib","nav__link":"_3KCif3Gac0ZvKY14TH6W2t","copyright__text":"_2wjLfrvW0ibRs_PL0KUcVE","icon-fb":"snLugXa09LyqGSEsthDSC","nav__item":"xZy3KgY0nYauVEN7Q0gzR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/footer.scss
// module id = 1166
// module chunks = 0